import classNames from 'classnames';

import { Icon } from '@/shared/ui';

import styles from './addToCart.module.scss';

interface AddCartProps {
  handleAddToCart?: () => void;
  handleAddToFavorites?: () => void;
  disabled?: boolean;
}

const AddToCart = (props: AddCartProps) => {
  const { handleAddToCart, disabled = false } = props;
  return (
    <div className={styles.container}>
      <button
        className={classNames('button button--md-black')}
        disabled={disabled}
        onClick={handleAddToCart}
      >
        <Icon name="plusBig" />В корзину
      </button>
    </div>
  );
};

export default AddToCart;
